"use client";

import {
  BarChart3,
  Code2,
  GitFork,
  Globe2,
  Network,
  ShieldCheck,
  Smartphone,
  Sparkles,
  Terminal,
  Users,
} from "@/components/icons";
import { MCP_FEATURES_COPY, MCP_TOOL_CATEGORIES_COPY } from "./content";
import type { IconComponent, McpFeature, McpToolCategory } from "./types";

const FEATURE_ICONS: Record<string, IconComponent> = {
  "natural-language": Sparkles,
  "smart-discovery": ShieldCheck,
  "any-client": Terminal,
  "one-command": Code2,
  analytics: BarChart3,
  "open-source": GitFork,
};

export const MCP_FEATURES: McpFeature[] = MCP_FEATURES_COPY.map((feature) => ({
  ...feature,
  icon: FEATURE_ICONS[feature.slug],
}));

const CATEGORY_ICONS: Record<string, IconComponent> = {
  account: Users,
  "per-proxy": Network,
  mobile: Smartphone,
  analytics: BarChart3,
  residential: Globe2,
};

export const MCP_CATEGORIES: McpToolCategory[] = MCP_TOOL_CATEGORIES_COPY.map((category) => ({
  ...category,
  icon: CATEGORY_ICONS[category.slug],
}));
